module.exports = __webpack_public_path__ + "img/icon-white-stream.cc55a9ae.svg";